import { FunctionComponent, memo } from "react";
import { Tooltip } from "@edgetier/components";
import { IProps } from "./ellipsis-tooltip-text.types";
import "./ellipsis-tooltip-text.scss";

/**
 * Display truncated text with a tooltip containing full text
 * @param props.children  Elements displayed
 */
const EllipsisTooltipText: FunctionComponent<IProps> = ({ children }) => {
    return (
        <Tooltip
            content={<div className="ellipsis-tooltip-text__tooltip-content">{children}</div>}
            delayEnter={250}
            useArrow
        >
            <div className="ellipsis-tooltip-text">{children}</div>
        </Tooltip>
    );
};

export default memo(EllipsisTooltipText);
